<template>
  <svg
    class="icon"
    :class="{'icon--spin':spin}"
    :height="size"
    viewBox="0 0 16 16"
    :width="size"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m4 6 4 3 4-3"
      fill="none"
      stroke-linecap="round"
      stroke-width="2"
      transform="matrix(1 0 0 -1 0 15)"
      style="stroke:currentColor;"
    />
  </svg>
</template>

<script setup>
import { baseIconProps } from '../base/use-base-icon.js';

defineProps(baseIconProps);

</script>
